module.exports = __webpack_public_path__ + "img/PP.3108f18d.png";